import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import StyledTab from '../../common/tabs/SimpleTab';
import SimpleTabs from '../../common/tabs/SimpleTabs';
import { a11yProps } from '../../../helpers/utils';
import TabPanel from '../../common/tabs/SimpleTabPanel';
import { Helmet } from 'react-helmet';
import SwipeableViews from 'react-swipeable-views';
import useDesktopDisplay from '../../../hooks/useDesktopDisplay';
import Birthday from '../Birthday';
import WorkStartAnniversary from '../WorkStartAnniversary';
import { useTranslation } from '../../../i18n/LanguageProvider';

const NotificationsList = () => {
  const { t, isRtl } = useTranslation();
  const dispatch = useDispatch();
  const isDesktop = useDesktopDisplay();
  const [tabIndex, setTabIndex] = useState(0);
  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabIndex(index);
  };
  useEffect(() => {
    setHeader(t('nav.occasions'));
    setHeaderConfigs({ credits: false, exit: false, back: true, logo: false });
  }, []);
  return (
    <div className={styles.page}>
      <Helmet>
        <title>{t('nav.occasions')}</title>
      </Helmet>
      {isDesktop && (
        <div className={styles.pageHeader}>
          <span>{t('nav.occasions')}</span>
        </div>
      )}
      <div className={styles.section}>
        <div className={styles.sectionTop}>
          <SimpleTabs value={tabIndex} handleChange={handleChange}>
            <StyledTab label={t('occasions.birthdays')} {...a11yProps(0)} />
            <StyledTab
              label={<div>{t('occasions.anniversaries')}</div>}
              {...a11yProps(1)}
            />
          </SimpleTabs>
        </div>

        <div className={classNames(styles.sectionBody, styles.noMargin)}>
          <SwipeableViews
            axis={isRtl ? 'x-reverse' : 'x'}
            index={tabIndex}
            onChangeIndex={handleChangeIndex}
            className={classNames(styles.swipeArea)}
          >
            <TabPanel
              index={0}
              value={tabIndex}
              className={styles.swipeablePage}
            >
              <Birthday />
            </TabPanel>
            <TabPanel
              index={1}
              value={tabIndex}
              className={styles.swipeablePage}
            >
              <WorkStartAnniversary />
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </div>
  );
};

export default NotificationsList;
